import React from 'react';
import FilterResult from '@components/filter-result/filter-result';
import styled from '@emotion/styled/macro';
import Translate from '@utils/translation-functions';
import vars from '@variables';
import { useInfiniteHits } from 'react-instantsearch';
import { FilterResultsBlockProps } from './filter-results-block.types';

const FilterResultsBlock: React.FC<FilterResultsBlockProps> = ({
  className,
}) => {
  const { hits, results, isLastPage, showMore } = useInfiniteHits();

  const totalResults = results?.nbHits ?? 0;
  const displayedResults = hits.length;

  return (
    <div className={className} role="main">
      <div className="ais-InfiniteHits">
        <ol className="ais-InfiniteHits-list">
          {hits.map((hit: any) => (
            <li key={hit.objectID} className="ais-InfiniteHits-item">
              <FilterResult hit={hit} />
            </li>
          ))}
        </ol>

        {totalResults > 0 && (
          <div className="results-count">
            Showing {displayedResults} of {totalResults} results
          </div>
        )}

        {!isLastPage && (
          <button
            className="ais-InfiniteHits-loadMore"
            onClick={showMore}
            type="button"
          >
            {Translate('Load more', true)}
          </button>
        )}
      </div>
    </div>
  );
};

const StyledFilterResultsBlock = styled(FilterResultsBlock)`
  .ais-InfiniteHits {
    .ais-InfiniteHits-list {
      width: 100%;
    }

    .ais-InfiniteHits-item {
      margin: 0 0 1.6rem 0;
      font-weight: ${vars.fontWeightRegular};
      width: 100%;

      a {
        width: 100%;
      }

      flex-grow: 1;

      &:last-child {
        margin-right: 0;
      }

      @media screen and (min-width: calc(${vars.breakPointTenColumn} + 1px)) and (max-width: calc(${vars.breakPointSmallTablet} - 1px)) {
        width: 45%;
        margin-right: ${vars.spacingS};
        margin-bottom: ${vars.spacingS};

        &:nth-of-type(2n) {
          margin-right: 0;
        }
      }

      @media screen and (min-width: ${vars.breakPointSmallTablet}) and (max-width: calc(${vars.breakPointTablet} - 1px)) {
        width: 28%;
        margin-right: ${vars.spacingS};
        margin-bottom: ${vars.spacingS};

        &:nth-of-type(3n) {
          margin-right: 0;
        }
      }

      @media screen and (min-width: ${vars.breakPointTablet}) and (max-width: calc(${vars.breakPointTwelveColumn} - 1px)) {
        width: 28%;
        max-width: 32.1%;
        margin-right: ${vars.spacingM};

        &:nth-of-type(3n) {
          margin-right: 0;
        }
      }

      @media screen and (min-width: ${vars.breakPointTwelveColumn}) and (max-width: 1299px) {
        width: 24%;
        max-width: 23.8%;
        margin-right: ${vars.spacingM};

        &:nth-of-type(4n) {
          margin-right: 0;
        }
      }

      @media screen and (min-width: 1300px) {
        width: 20%;
        max-width: 18.8%;
        margin-right: 1.8rem;
        margin-bottom: ${vars.spacingL};

        &:nth-of-type(5n) {
          margin-right: 0;
        }
      }
    }

    .results-count {
      margin-top: ${vars.spacingL};
      text-align: center;
      font-size: 1.2rem;
    }

    .ais-InfiniteHits-loadMore {
      display: block;
      margin: ${vars.spacingS} auto;
    }
  }
`;

export default StyledFilterResultsBlock;
